import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageIcon } from "@/lib/icons";
import { Panel } from "@/components/common";
import SubscriptionsTable from "@/components/SubscriptionsTable";
import SubscriptionsSummary from "@/components/SubscriptionsSummary";
import DocumentsList from "@/components/DocumentsList";

export default function ClientPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/portal/pages/${id}`).then((r) => setData(r.data));
  }, [id]);
  if (!data) return null;
  const { page, subscriptions, documents } = data;
  return (
    <div key={id}>
      <div className="fade-up flex items-start gap-5 mb-10">
        <div className="h-14 w-14 shrink-0 rounded-lg bg-blue-600/15 border border-blue-500/30 grid place-items-center text-blue-400">
          <PageIcon name={page.icon} size={26} />
        </div>
        <div>
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight" data-testid="page-title">{page.title}</h1>
          {page.description && <p className="mt-2 text-slate-400 max-w-2xl">{page.description}</p>}
        </div>
      </div>
      {page.content && (
        <div className="fade-up mb-8 rounded-lg border border-slate-800 bg-slate-900/40 p-5 text-sm text-slate-300 whitespace-pre-wrap leading-relaxed" data-testid="page-content">
          {page.content}
        </div>
      )}
      <div className="space-y-6">
        {page.show_subscriptions && (
          <Panel title={`Abbonamenti (${subscriptions.length})`} testid="page-subscriptions">
            <SubscriptionsTable items={subscriptions} />
            <SubscriptionsSummary items={subscriptions} />
          </Panel>
        )}
        {page.show_documents && (
          <Panel title={`Documenti (${documents.length})`} testid="page-documents">
            <DocumentsList items={documents} />
          </Panel>
        )}
      </div>
    </div>
  );
}
